import { getStore } from "app/store/store"
import { localStorageSVC } from "app/util/local-storage/service"
import { userEventModule } from "user/event"
import { IUserInfo, LOCAL_STORAGE_TOKEN, USER_EVENTS } from "user/model"
import { userRPO } from "user/repository"
import { userActionCreator } from "user/store/actions"
import { getSessionExpirationTimeInMilliSeconds, getUserInfo, keepTokenValid, logout, setUserInfo } from "./common"

// 180000 ms = 3 minutes
export const RENEW_SESSION_CHECK_TIME_IN_MS = 180000

export async function checkRenewSession(userInfo: IUserInfo): Promise<void> {
  const email = userInfo.impersonate ? userInfo.impersonate.email : userInfo.user.email
  if (!email) {
    if (getSessionExpirationTimeInMilliSeconds(userInfo) === 0) {
      await logout()
    } // else we are not yet loggued
  } else {
    if (getSessionExpirationTimeInMilliSeconds(userInfo) <= RENEW_SESSION_CHECK_TIME_IN_MS) {
      // Try renew session
      try {
        await renewSession(email)
      } catch (error) {
        console.error(error)
        // open relogin popup if unable to renew
        // It ask user to input his password 3 minutes before being logout
        // Get a new user session id and avoid logout
        getStore().dispatch(userActionCreator.openReLoginPopup())
      }
    }
  }
}

export const renewSession = async (email: string) => {
  const newUserInfo = await userRPO.renewSession(email)
  keepTokenValid(newUserInfo)
  getStore().dispatch(userActionCreator.renewSession(newUserInfo))
  userEventModule.notify(USER_EVENTS.RENEW_SESSION, newUserInfo)
}

export function reLogin(clearPassword: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    userRPO
      .login(getUserInfo().user.email as string, clearPassword)
      .then(newUserInfo => {
        const inLocalStorageOldToken = localStorageSVC.get(LOCAL_STORAGE_TOKEN)
        if (inLocalStorageOldToken) {
          // that means remenber me was checked so we keep storing the token
          localStorageSVC.set(LOCAL_STORAGE_TOKEN, newUserInfo.token)
        }
        setUserInfo(newUserInfo)
        resolve()
      })
      .catch(errorKey => reject(errorKey))
  })
}
